"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _dateformart = require("@/utils/dateformart");

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// secondary package based on el-pagination
// Custom Table Column Mixins (Omega Theme)
var _default = {
  name: "loginLog:view",
  extends: _PermissionPage.default,
  components: {
    Pagination: _Pagination.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      queryParameter: {
        pageNum: 1,
        pageSize: 10,
        loginUser: "",
        loginTime: [(0, _dateformart.getTodayBegin)(), (0, _dateformart.getNowLessOneSecond)()]
      },
      downloadLoading: false,
      multipleSelection: []
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;

      var params = this.getQueryParams();
      this.listLoading = true;

      _httpUtils.default.post("loginLog", "list", null, params).then(function (res) {
        //let index;
        _this.list = res.data.rows;
        _this.total = res.data.total;
      });

      setTimeout(function () {
        _this.listLoading = false;
      }, 1 * 1000);
    },
    getQueryParams: function getQueryParams() {
      if (this.queryParameter.loginTime == null) {
        return {
          pageNum: this.queryParameter.pageNum,
          pageSize: this.queryParameter.pageSize,
          username: this.queryParameter.loginUser,
          loginTimeFrom: (0, _dateformart.getTodayBegin)(),
          loginTimeTo: (0, _dateformart.getNowLessOneSecond)()
        };
      } else {
        return {
          pageNum: this.queryParameter.pageNum,
          pageSize: this.queryParameter.pageSize,
          username: this.queryParameter.loginUser,
          loginTimeFrom: this.queryParameter.loginTime[0],
          loginTimeTo: this.queryParameter.loginTime[1]
        };
      }
    },
    handleFilter: function handleFilter() {
      this.queryParameter.pageNum = 1;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};
exports.default = _default;